<script setup lang="ts">
import {Dialog, DialogPanel, TransitionChild, TransitionRoot} from '@headlessui/vue';
import {ref, watch} from 'vue';
import {useStore} from '../store';

const store = useStore();

const isOpen = ref(false);
watch(() => store.playVideo, (val, oldVal) => {
    if (val !== undefined && oldVal === undefined) {
        isOpen.value = true;
    }
});

const closeModal = () => {
    isOpen.value = false;
};

const onAfterClose = () => {
    store.setPlayVideo();
};
</script>

<template>
    <TransitionRoot :show="isOpen" as="template" @afterLeave="onAfterClose">
        <Dialog class="modal" @close="closeModal">
            <TransitionChild
                as="template"
                enter="modal-shade-enter-active"
                enter-from="modal-shade-enter-from"
                enter-to="modal-shade-enter-to"
                leave="modal-shade-leave-active"
                leave-from="modal-shade-leave-from"
                leave-to="modal-shade-leave-to"
            >
                <div class="modal-shade" />
            </TransitionChild>
            <div class="modal-scroller">
                <div class="modal-inner">
                    <TransitionChild
                        as="template"
                        enter="modal-enter-active"
                        enter-from="modal-enter-from"
                        enter-to="modal-enter-to"
                        leave="modal-leave-active"
                        leave-from="modal-leave-from"
                        leave-to="modal-leave-to"
                    >
                        <DialogPanel class="modal-panel">
                            <button type="button" class="modal-close" @click="closeModal">
                                <svg viewBox="0 0 32 32" width="32" height="32">
                                    <use xlink:href="#icon-close" />
                                </svg>
                            </button>
                            <div
                                class="video-player"
                                v-html="store.playVideo.embed"
                            />
                        </DialogPanel>
                    </TransitionChild>
                </div>
            </div>
        </Dialog>
    </TransitionRoot>
</template>
